<template>
  <div class="flex items-start">
    <div style="display: flex; flex-direction: row; align-items: center;" :class="[{'principal': true}]">
      <div
        class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
        style="float: right;"
        :class="{
            'bg-primary-gradient text-white': (!status.type) && !status.is_bot_message,
            'text-black': type === 'customer-customer' || status.type===1 && type === 'agent-customer',
            'is-bot-message text-white': !status.type && status.is_bot_message,
            'text-white': type === 'agent-customer' && status.type === 0,
            'border border-solid border-grey-light bg-white': status.type
        }"
      >
        <div v-if="status.mimetype === 'location' && statusDecode !== null">
          <gmap-map
              :zoom="zoomMap"
              :center="{
                  lat: statusDecode.lat,
                  lng: statusDecode.lng
                }"
              :options="settingsMap"
              style="width: 24em;  height: 24em;"
          >
            <gmap-marker
                @click="openMap"
                :optimized="false"
                :position="{
                    lat: statusDecode.lat,
                    lng: statusDecode.lng
                }"
            ></gmap-marker>
          </gmap-map>

          <div class="mt-5">
            <strong><a class="text-black" v-if="statusDecode.place" :href="statusDecode.url" target="_blank">{{statusDecode.place}}</a></strong>
            <p v-if="statusDecode.address">{{statusDecode.address}}</p>
            <p v-if="statusDecode.comment">{{statusDecode.comment}}</p>
          </div>
        </div>

        <div v-else-if="status.mimetype === 'payment' && statusDecode !== null">
          <div class="is-payment-message rounded">
              <div class="flex justify-center items-center p-8">
                  <p class="font-bold text-lg">{{ maskMoney(statusDecode.amount, statusDecode.currency) }}</p>
              </div>
          </div>

          <div style="white-space: pre-line;" v-if="statusDecode.message.type === 'image' || statusDecode.message.type === 'sticker'">
              <img :src="statusDecode.message.url" :alt="statusDecode.message.body" style="max-width: 100%;" />
          </div>
          <div style="white-space: pre-line;" v-else-if="statusDecode.message.type === 'chat'">
              <div class="msg-render" v-html="statusDecode.message.body"></div>
          </div>
        </div>

        <div v-else-if="status.mimetype.split('/')[0] === 'image' || status.mimetype === 'sticker'">
          <img :src="status.url" style="max-width: 100%;" />
        </div>

        <div v-else-if="status.mimetype.split('/')[0] === 'video'">
            <video width="100%" height="240" controls>
                <source
                    :src="status.url"
                    type="video/mp4"
                >
            </video>
        </div>

        <div v-else-if="status.mimetype === 'audio' || status.mimetype === 'ptt'">
            <audio controls>
                <source
                    :src="status.url"
                    type="audio/ogg"
                >
            </audio>
        </div>

        <div v-else-if="status.mimetype === 'contact' && statusDecode !== null">
            <div class="flex">
                <vs-avatar size="large" :src="statusDecode.image"/>
                <b class="ml-3 self-center">{{statusDecode.name}}</b>
            </div>
        </div>

        <div v-else style="white-space: pre-line;">{{ status.caption }}</div>

        <p align="right">
            <small>
                Mensagem vinculada ao status
            </small>
        </p>

        <slot></slot>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import {maskMoney} from "@/utils";

export default{
    props: {
        type: {
            default: null,
            type: String
        },
        status: {
            default: null,
            type: Object
        },    
        
    },
    data() {
      return {
        zoomMap: 17,
        redirectUrl: 'https://www.google.com.br/maps/place/',
        settingsMap: {
          zoomControl: true,
          scaleControl: false,
          rotateControl: false,
          mapTypeControl: false,
          disableDefaultUi: false,
          streetViewControl: false,
          fullscreenControl: false,
        }
      };
    },
    computed: {
        slotInUse() {
            return this.$slots.default
        },
        statusDecode() {
          return this.decodeData(this.status.caption)
        }
    },
    methods: {
        maskMoney,
        decodeData(data){
          try { return JSON.parse(data) }
          catch (error) { return null }
        },
        openMap(){
          const url = this.redirectUrl + this.statusDecode.lat + ',' + this.statusDecode.lng;
          window.open(url, '_blank');
        },
        scrollToBottom() {
            this.$nextTick(() => {
                this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight
            });
        },
        downloadDocument(url, documentName, documentMimetype) {
            axios.get(url, {
                responseType: 'blob'
            }).then(res => {
                var blob = new Blob(
                    [res.data],
                    { type: `${documentMimetype};charset=utf-8;` }
                )
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = documentName
                link.click()
                window.URL.revokeObjectURL(link.href)
            })
        },
        getExtension(text) {
            const split = text.split('.')
            return split[split.length - 1]
        },
        isOggAudio(message) {
            return message.endsWith('.ogg')            
        },
        isOgaAudio(message) {
            return message.endsWith('.oga')
        },
        isFalseAudio(message) {
            return message.endsWith('.false')
        },
        isMp3Audio(message) {
            return message.endsWith('.mp3')
        },
        isMpegAudio(message) {
            return message.endsWith('.mpe')
        },
        isMpgaAudio(message) {
            return message.endsWith('.mpga')
        }
    }
}
</script>


<style>
.is-bot-message {
    background: linear-gradient(118deg, rgba(0, 208, 227, 1), rgba(0, 208, 227, 0.7)) !important;
}
.text-black {
    color: #6B7589 !important;;
}

.force-revert-flex{
    flex-direction: row !important;
}

.force-revert-revert-flex {
    flex-direction: row-reverse !important;
}

.reply-message {
    position: absolute !important;
    top: -3px;
    right: -8px;
    background: #89c5ed;
    color: #ffff;
    border-radius: 24px !important;
    border: 0px solid;
    width: 20px !important;
    height: 20px;
    text-align: center !important;
    font-size: 14px !important;
    vertical-align: middle;
    line-height: revert;
    cursor: pointer;
}
</style>
